import { getDashboard } from "api/dashboard";
import { deepSearch, useAppDispatch } from "util/hooks";
import { setIssuesList, setLoading } from "store/appSlice";
import { DashboardReqBody, Section } from "api/types/dashboard";
import { useEffect } from "react";
import { usePermissions } from "hooks/usePermissions";
import Issues from "../components/Issues";
import Generic from "../components/Generic";
import { shallowEqual, useSelector } from "react-redux";
import { getDashboardActions } from "store/page/pageSelectors";
import { setDashboardActions } from "store/page/pageSlice";

const IssuesDashboard = () => {
  const dispatch = useAppDispatch();
  const metrics = useSelector(getDashboardActions, shallowEqual);
  const { canShow } = usePermissions();

  const getDashboardData = async () => {
    const sections: DashboardReqBody = {
      sections: [
        Section.DEVICE_COUNT,
        Section.DEVICES_DOWN,
        Section.ZERO_COUNT,
        Section.LEAKING,
        Section.WEAK_SIGNAL,
        Section.LOW_BATTERY,
        Section.WATER_BREAKDOWN,
        Section.ELECTRICITY_BREAKDOWN,
        Section.TEMPERATURE_BREAKDOWN,
        Section.LEVEL_BREAKDOWN,
        Section.GAS_BREAKDOWN,
      ],
    };
    if (!metrics.deviceCount) dispatch(setLoading(true));
    const { data, isLoading, status } = await getDashboard(sections);
    dispatch(setLoading(isLoading));
    if (status === 200) {
      dispatch(
        setDashboardActions({
          ...metrics,
          deviceCount: data?.deviceCount,
          zeroCount: data?.zeroCount,
          devicesDown: data?.devicesDown,
          leaking: data?.leaking,
          weakSignal: data?.weakSignal,
          water: data?.water,
          electricity: data?.electricity,
          temperature: data?.temperature,
          level: data?.level,
          gas: data?.gas,
        })
      );
      const deepData = deepSearch(data);
      dispatch(setIssuesList(deepData));
    }
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  return (
    <div className={`mt-2`}>
      <div className={`flex h-full flex-col gap-2`}>
        <div className="flex flex-col gap-2 py-1 lg:flex-row lg:overflow-x-auto">
          <div className="min-w-[300px] flex-1">
            <Generic
              count={metrics?.deviceCount}
              color="50"
              textColor="white"
              extra="min-h-48"
              context="total"
            />
          </div>
          <div className="min-w-[300px] flex-1">
            <Generic
              metrics={metrics?.zeroCount}
              color="100"
              textColor="white"
              extra="min-h-48"
              context="zerocount"
            />
          </div>
          <div className="min-w-[300px] flex-1">
            <Generic
              metrics={metrics?.devicesDown}
              color="200"
              textColor="white"
              extra="min-h-48"
              context="down"
            />
          </div>
          <div className="min-w-[300px] flex-1">
            <Generic
              metrics={metrics?.leaking}
              color="300"
              textColor="white"
              extra="min-h-48"
              context="leaking"
            />
          </div>
          <div className="min-w-[300px] flex-1">
            <Generic
              metrics={metrics?.weakSignal}
              color="400"
              textColor="white"
              extra="min-h-48"
              context="weaksignal"
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 py-1 lg:flex-row lg:overflow-x-auto">
          <div className="h-full min-w-[300px] flex-1">
            <Issues type="water" metrics={metrics?.water} />
          </div>
          <div className="h-full min-w-[300px] flex-1">
            <Issues type="electricity" metrics={metrics?.electricity} />
          </div>
          <div className="h-full min-w-[300px] flex-1">
            <Issues type="temperature" metrics={metrics?.temperature} />
          </div>
          <div className="h-full min-w-[300px] flex-1">
            <Issues type="level" metrics={metrics?.level} />
          </div>
          <div className="h-full min-w-[300px] flex-1">
            <Issues type="gas" metrics={metrics?.gas} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IssuesDashboard;
